import api from './api';

export const uisTrackerAPI = {
  getIndicatorStatus: (params?: { academic_year?: string }) =>
    api.get('/sis-integration/uis-tracker/', { params }),

  getCompleteness: (params?: { academic_year?: string }) =>
    api.get('/sis-integration/uis-tracker/completeness/', { params }),
};
